// Will hold code to handle recently viewed

// Need to build backend
var Cookies = require('js-cookie');
var jquery = require('jquery');
var myname = 'Recents';
var data = [];
var LFPortal = null;
var cookiename = 'RECENTPROPERTIES';


function _exists(reference){
	// console.log('%s.%s()', myname, arguments.callee.name, arguments);
	return (_findIdx(reference)>=0)?true:false;
}

function _findIdx(reference){
	reference = reference.toLowerCase();
	return data.findIndex(function(property){
		return property.reference.toLowerCase() === reference;
	});
}

function _add_item(property){
	// console.log('%s.%s()', myname, arguments.callee.name, arguments);
	var idx = _findIdx(property.reference);
	if(idx >= 0){
		// Already exists : Remove
		data.splice(idx, 1);
	}
	// Check to see if it is also a favourite
	property.isfav = LFPortal.Favs.isFav(property.reference);
	data.unshift(property);
	// TODO: Maybe save to cookie here to make the cookie data the same as the cp
	_saveToCookie(property.reference);
	return;
}

function _saveToCookie(reference){
	// console.log('%s.%s()', myname, arguments.callee.name, arguments);
	reference = reference.toLowerCase();
	// Get the current cookie
	var refs = Cookies.get(cookiename);
	if(refs !== undefined){
		refs = refs.toLowerCase();
		refs = refs.split(',');
	}else{
		refs = [];
	}
	// Remove existing reference
	refs = refs.filter(function(value){
		return (
			value != reference
			&& value != ''
		);
	});
	refs.unshift(reference);
	refs.slice(0, 12);
	// Store the most recent refs in the old-school Cookie too 
	// so that we can access it when not logged in
	Cookies.set(cookiename, refs.join(','), {path:'/', expires: 7});
}

// Public methods

function init(P){
	// console.info('%s.%s()', myname, arguments.callee.name);
	LFPortal = P;
}

// function reflist(){
// 	// returns a comma sep list of references for the current data
// 	return data.reduce(function(acc, value){
// 			return acc.concat(value.reference);
// 		},[])
// 		.slice(0, 11)
// 		.join(',')
// 	;
// }

function setData(props){
	// console.log('%s.%s()', myname, arguments.callee.name, arguments);
	props.forEach(function(prop){
		data.push(prop);
	});
}

function clearData(){
	// console.log('%s.%s()', myname, arguments.callee.name, arguments);
	data = [];
}




function add(reference){
	// console.log('%s.add(%s)', myname, reference);
	// Always save to cookie
	if(!LFPortal.dataset.ok){
		_saveToCookie(reference);
		return;
	}
	if(!reference.length){ return };
	jquery.ajax({
			url:LFPortal.endpoint('recent')
		,	method: 'POST'
		, dataType: 'JSON'
		, contentType: 'application/json; charset=utf-8'
		, headers: {'Authorization': LFPortal.token()}
		, data: JSON.stringify({reference:reference})
	})
	.done(function(data, textStatus, jqXHR){
		_add_item(data);
		return;
	})
	.fail(function(xhr, status, errorThrown){
		// console.log(arguments);
	});
	return;

}



export default {
	init,
	add,
	setData,
	clearData,
	data,
};


// WEBPACK FOOTER //
// ./src/portal/recents.js